import { render, staticRenderFns } from "./PostpayNews.vue?vue&type=template&id=0b80b78c&"
import script from "./PostpayNews.vue?vue&type=script&lang=js&"
export * from "./PostpayNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports